import { VersionText } from "../../atoms/TextField"
import { useTranslation } from "react-i18next";

export const AppVersion = (props) => {
    const { t } = useTranslation();
    const { page } = props;
    const ifApplicable = ["localhost", "dev-useast1.wvmobile.org", "qa-useast1.wvmobile.org", "stg-portal.wvmobile.org", "stg-connect.worldvision.org.nz"].includes(window.location.hostname);
    const hostname = window.location.hostname;
    const version = () => {
        if (["stg-portal.wvmobile.org", "stg-connect.worldvision.org.nz"].includes(hostname)) return process.env.REACT_APP_STG_VERSION;
        if (["qa-useast1.wvmobile.org"].includes(hostname)) return process.env.REACT_APP_QA_VERSION;
        if (["localhost", "dev-useast1.wvmobile.org"].includes(hostname)) return process.env.REACT_APP_DEV_VERSION;
        return "";
    }
    return (
        ifApplicable && version() !== "" && <VersionText page={page}>{t("DT_WVM_ACC_HEAD_00097_Vers")} {version()}</VersionText>
    )
}

export const AppVersionNumber = () => {
    const hostname = window.location.hostname;
    const version = () => {
        if (["portal.wvmobile.org"].includes(hostname)) return process.env.REACT_APP_PROD_VERSION;
        if (["stg-portal.wvmobile.org", "stg-connect.worldvision.org.nz"].includes(hostname)) return process.env.REACT_APP_STG_VERSION;
        if (["qa-useast1.wvmobile.org"].includes(hostname)) return process.env.REACT_APP_QA_VERSION;
        if (["localhost", "dev-useast1.wvmobile.org"].includes(hostname)) return process.env.REACT_APP_DEV_VERSION;
        return "";
    }
    return version;
}